module.exports = __webpack_public_path__ + "img/OTMS_Onboarding_HeaderAnim_EN.ebb7c9be.png";